// src/pages/ProjectDetailsPage.tsx
// نام فایل: ProjectDetailsPage.tsx
import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { fetchProject, deleteProject } from "../api/projects"; // اضافه شد
import TaskCard from "../components/TaskCard";
import "../styles/ProjectDetailsPage.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft, faShareAlt, faTrash } from "@fortawesome/free-solid-svg-icons"; // آیکون حذف
import { ApiProject, API_BASE } from "../api/api";
import { useUser } from "../contexts/UserContext";  // اضافه شد
import ShareProjectForm from "../components/ShareProjectForm";

interface TaskNote {
    id: number;
    content: string;
    createdById: number;
    createdAt: string;
    updatedAt?: string;
    isDone?: boolean;
}

interface Task {
    id: number;
    title: string;
    description: string;
    isDone: boolean;
    createdById?: number | null;
    notes: TaskNote[];
    createdAt: string;
    updatedAt?: string;
}

interface Project {
    id: number;
    title: string;
    description?: string;
    createdById?: number;
    createdAt?: string;
    updatedAt?: string;
    tasks: Task[];
}

export default function ProjectDetailsPage() {
    const { id } = useParams<{ id: string }>();
    const [project, setProject] = useState<Project | null>(null);
    const [loading, setLoading] = useState(true);
    const navigate = useNavigate();
    const currentUserId = Number(localStorage.getItem("userId") ?? 0);
    const [shareModalOpen, setShareModalOpen] = useState(false);
    const { user, setUser } = useUser(); // گرفتن اطلاعات کاربر از کانتکست

    const loadProject = async () => {
        if (!id) return;
        setLoading(true);
        try {
            console.log("در حال دریافت پروژه با آیدی:", id);
            const username = localStorage.getItem("username");
            console.log("نام کاربری:", username);

            const res = await fetch(`${API_BASE}/projects/${id}?username=${encodeURIComponent(username || "")}`);
            console.log("وضعیت پاسخ:", res.status, res.statusText);

            if (!res.ok) {
                const errorText = await res.text();
                console.error("متن خطا از سرور:", errorText);
                throw new Error(`خطا ${res.status}: ${errorText}`);
            }

            const data1 = await res.json();
            console.log("داده دریافت‌شده از سرور:", data1);

            const data: ApiProject = await fetchProject(Number(id));
            if (data) {
                const normalizedTasks: Task[] = (data.tasks ?? []).map((t: any) => ({
                    id: t.id ?? t.taskItemId ?? 0,
                    title: t.title ?? "",
                    description: t.description ?? "",
                    isDone: t.isDone ?? false,
                    createdById: t.createdById ?? null,
                    createdAt: t.createdAt ?? new Date().toISOString(),
                    updatedAt: t.updatedAt,
                    notes: (t.notes ?? []).map((n: any) => {
                        if (typeof n === "string") {
                            return {
                                id: 0,
                                content: n,
                                createdById: currentUserId,
                                createdAt: new Date().toISOString(),
                            };
                        }
                        return {
                            id: n.id ?? n.taskNoteId ?? 0,
                            content: n.content ?? "",
                            createdById: n.createdById ?? currentUserId,
                            createdAt: n.createdAt ?? new Date().toISOString(),
                            updatedAt: n.updatedAt ?? n.UpdatedAt,
                            isDone: n.isDone ?? false,
                        };
                    }),
                }));

                setProject({
                    id: data.id ?? data.projectId ?? 0,
                    title: data.title ?? "",
                    description: data.description ?? "",
                    createdById: data.createdById ?? undefined,
                    createdAt: data.createdAt ?? new Date().toISOString(),
                    updatedAt: data.updatedAt,
                    tasks: normalizedTasks,
                });
            }
        } catch (err: any) {
            console.error("خطا در دریافت پروژه:", err);
            alert(`خطا در بارگذاری پروژه: ${err.message || "نامشخص"}`);
            setProject(null);
        } finally {
            setLoading(false);
        }
    };

    const handleDeleteProject = async () => {
        if (!project) return;
        const taskCount = project.tasks.length;
        const confirmed = window.confirm(
            `آیا مطمئن هستید که می‌خواهید پروژه "${project.title}" را حذف کنید؟\n` +
            `این پروژه دارای ${taskCount} تسک است و همه آنها نیز حذف خواهند شد.\n` +
            `این عملیات قابل برگشت نیست.`
        );
        if (!confirmed) return;

        try {
            await deleteProject(project.id);
            alert("پروژه با موفقیت حذف شد.");
            navigate("/projects"); // برگشت به لیست پروژه‌ها
        } catch (err: any) {
            alert(`خطا در حذف پروژه: ${err.message || "نامشخص"}`);
        }
    };


    useEffect(() => {
        loadProject();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [id]);

    if (loading) return <div className="loading">در حال بارگذاری پروژه...</div>;
    if (!project) return <div className="error">پروژه یافت نشد یا خطایی رخ داده است.</div>;


    return (
        <div className="appGlobal">
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-end", marginBottom: 16 }}>
                <div style={{ position: 'absolute', top: 'calc(var(--app-header-height) * 1.4)', left: 10, display: "flex", flexDirection: "column", alignItems: "flex-end", gap: 8 }}>
                    <button
                        className="deleteButton"
                        onClick={handleDeleteProject}
                        style={{
                            backgroundColor: "red",
                            color: "white",
                            padding: "6px 12px",
                            borderRadius: 6,
                            marginRight: 5,
                            width: "40px",
                        }}
                    >
                        <FontAwesomeIcon icon={faTrash} />
                    </button>

                    {!shareModalOpen && (
                        <button
                            onClick={() => setShareModalOpen(true)}
                            style={{
                                backgroundColor: "blue",
                                color: "white",
                                padding: "6px 12px",
                                borderRadius: 4,
                                width: "40px",
                            }}
                        >
                            <FontAwesomeIcon icon={faShareAlt} />
                        </button>
                    )}
                </div>

                <h2 style={{ textAlign: "center", flex: 1 }}>
                    لیست تسک‌های پروژه: {project.title}
                </h2>
            </div>
            {user && (
                <div style={{ marginTop: 16 }}>
                    <ShareProjectForm
                        projectId={project.id}
                        isOpen={shareModalOpen}
                        onClose={() => setShareModalOpen(false)}
                        onSuccess={(displayName) => {
                            alert(`پروژه با ${displayName} به اشتراک گذاشته شد.`);
                        }}
                    />
                </div>
            )}

            <TaskCard
                projectId={project.id}
                tasks={project.tasks}
                currentUserId={currentUserId}
                onTasksUpdate={(updatedTasks) =>
                    setProject((prev) => (prev ? { ...prev, tasks: updatedTasks } : prev))
                }
            />
        </div>
    );

}
